import {OrderFormState} from '@yandex-delivery/form/ui/OrderForm/types'
import {useCallback} from 'react'
import {useFormContext} from 'react-hook-form'

import {useActionContext} from '../../contexts/ActionContext'

export const useOrderAction = (): {triggerAction: VoidFunction} => {
  const {handleSubmit} = useFormContext<OrderFormState>()

  const {onSubmit} = useActionContext()

  const triggerAction = useCallback(() => {
    handleSubmit(data => {
      onSubmit(data)
    })()
  }, [handleSubmit, onSubmit])

  return {triggerAction}
}
